import type {Editor} from 'grapesjs';
import {useEditorUndoRedoState} from '@Hooks/useEditorUndoRedoState';
import type {EditorUndoRedoState} from '@Hooks/useEditorUndoRedoState';
import {canRedo, canUndo} from '@FormMakerReact/lib/form-maker-canvas-library';

export type {EditorUndoRedoState as UndoRedoState};

export function useUndoRedoState(editor: Editor | null): EditorUndoRedoState {
  return useEditorUndoRedoState(editor, canUndo, canRedo);
}
